export const placementInitialDataDTO: PlacementInitialDataDTO = data => {
  const { formats } = data

  /**
   * Product
   */

  const productFormat = formats.find(item => item.type === 'product')
  const hasProductSize = !!productFormat

  const product = {
    quantity: productFormat?.quantity || null,
    id: productFormat?.id || undefined
  }

  /**
   * Banner
   */

  const bannerFormats = formats.filter(item => item.type === 'banner')
  const hasBannerSize = !!bannerFormats?.length

  const bannerFormatsActiveSizes = bannerFormats.reduce(
    (acc, item) => ({ ...acc, [item.size]: true }),
    {}
  )

  const bannerFormatSizes = bannerFormats.reduce(
    (acc, item) => ({
      ...acc,
      [item.size]: {
        quantity: item.quantity,
        id: item.id
      }
    }),
    {}
  )

  const banner = {
    sizesActive: bannerFormatsActiveSizes,
    sizes: bannerFormatSizes
  }

  /**
   * Banner Video
   */

  const bannerVideoFormats = formats.filter(
    item => item.type === 'banner_video'
  )
  const hasBannerVideoSize = !!bannerVideoFormats?.length
  const bannerVideoFormatsActiveSizes = bannerVideoFormats.reduce(
    (acc, item) => ({ ...acc, [item.size]: true }),
    {}
  )

  const bannerVideoFormatSizes = bannerVideoFormats.reduce(
    (acc, item) => ({
      ...acc,
      [item.size]: {
        quantity: item.quantity,
        id: item.id
      }
    }),
    {}
  )
  const banner_video = {
    sizesActive: bannerVideoFormatsActiveSizes,
    sizes: bannerVideoFormatSizes
  }

  /**
   * Banner Off Site
   */

  const bannerOffSiteFormats = formats.filter(
    item => item.type === 'banner_off_site'
  )
  const hasBannerOffSiteSize = !!bannerOffSiteFormats?.length

  const bannerOffSiteFormatsActiveSizes = bannerOffSiteFormats.reduce(
    (acc, item) => ({ ...acc, [item.size]: true }),
    {}
  )

  const bannerOffSiteFormatSizes = bannerOffSiteFormats.reduce(
    (acc, item) => ({
      ...acc,
      [item.size]: {
        quantity: item.quantity,
        id: item.id
      }
    }),
    {}
  )
  const banner_off_site = {
    sizesActive: bannerOffSiteFormatsActiveSizes,
    sizes: bannerOffSiteFormatSizes
  }

  return {
    name: data.name,
    full_name: data.full_name,
    description: data.description,
    context: data.context,
    formats: {
      active: {
        banner: hasBannerSize,
        product: hasProductSize,
        banner_off_site: hasBannerOffSiteSize,
        banner_video: hasBannerVideoSize,
        sponsored_brand: false,
        sponsored_brand_video: false,
        digital_signage: false
      },
      banner,
      product,
      banner_off_site,
      banner_video,
      sponsored_brand: { quantity: null, id: undefined },
      sponsored_brand_video: { quantity: null, id: undefined },
      digital_signage: { quantity: null, id: undefined }
    }
  }
}
